export default "__VITE_ASSET__YkB2R6$k__"